export default __webpack_public_path__ + "static/media/style1.c758f231.svg";